<template>
  <div>

    <div style="width: 100%;">

      <div class="d-flex" style="position: absolute; z-index: 2;">

        <Button
          :size="15"
          color="#fd7e14"
          colorText="#ffffff"
          tooltip="Filtrar contenido"
          icon="fas fa-filter"
          round
          :width="30"
          class="mt-2 mb-3 mr-2"
          @click.native="openModal('modal', 1); ActionSetZindexTablaModal(true);"
          traslate
        />

        <Button
          :size="15"
          color="#dc3545"
          colorText="#ffffff"
          tooltip="Borrar contenido Filtrado"
          icon="fas fa-filter"
          round
          :width="30"
          class="mt-2 mb-3 mr-2"
          traslate
          @click.native="removeFilters()"
        />

        <Button
          :size="15"
          color="#28a745"
          colorText="#ffffff"
          tooltip="Exportar a Excel"
          icon="icon fas fa-file-excel"
          round
          :width="30"
          class="mt-2 mb-3 mr-2"
          @click.native="openModal('modal', 2); ActionSetZindexTablaModal(true);"
          traslate
        />

      </div>

    </div>

    <ui-modal :title="is_report_filter ? 'Filtrar datos para reporte de tracking' : 'Filtros para tracking'"
              ref="modal"
              size="large"
              @close="ActionSetZindexTablaModal(false)">

      <div class="form-group row p-2">

        <ui-textbox
          class="col-6"
          label="ID Booking"
          placeholder="Ingrese ID Booking"
          v-model="id_booking">
        </ui-textbox>

        <ui-select
          class="col-6"
          has-search
          label="Cliente"
          placeholder="Seleccionar"
          searchPlaceholder="Buscar"
          :keys="{ label: 'name', value: 'id' }"
          :options="listaClientes"
          v-model="customer">
        </ui-select>

      </div>

      <div class="form-group row p-2">

        <ui-textbox
          class="col-6"
          label="Número Booking HBL"
          placeholder="Ingrese Número Booking HBL"
          v-model="booking_number">
        </ui-textbox>

        <ui-textbox
          class="col-6"
          label="Número Booking MBL"
          placeholder="Ingrese Número Booking MBL"
          v-model="carrier_booking_number">
        </ui-textbox>

      </div>

      <div class="form-group row p-2">

        <ui-select
          :class="usuarioActual.id_role === 1 || usuarioActual.id_role === 9999 || usuarioActual.id_role === 2 || usuarioActual.id_role === 5 ? 'col-6' : 'col-12'"
          has-search
          label="Estado del Embarque"
          placeholder="Seleccionar"
          searchPlaceholder="Buscar"
          :keys="{ label: 'name', value: 'id' }"
          :options="[
            { id: '1', name: 'En tránsito' },
            { id: '2', name: 'Arribado' }
          ]"
          v-model="status">
        </ui-select>

        <ui-select v-if="usuarioActual.id_role === 1 || usuarioActual.id_role === 9999 || usuarioActual.id_role === 2 || usuarioActual.id_role === 5"
          class="col-6"
          has-search
          label="Estado atrasado/adelantado"
          placeholder="Seleccionar"
          searchPlaceholder="Buscar"
          :keys="{ label: 'name', value: 'id' }"
          :options="[
            { id: 1, name: 'Adelantado' },
            { id: 2, name: 'Atrasado' },
            { id: 3, name: 'A tiempo' }
          ]"
          v-model="delay_status">
        </ui-select>

      </div>

      <div class="form-group row p-2">

        <div class="col-6">
          <div style="color: grey; font-size: 15px">Nave</div>
          <multiselect
            placeholder="Seleccionar"
            :options="dataListaNave"
            :searchable="true"
            v-model="vessels"
            :multiple="true"
            label="name"
            track-by="name"
            :limit="1"
            :limitText=" count => `+ ${count} registros` "
            selectLabel="Agregar"
            deselectLabel="Quitar"
            selectedLabel="Agregado"
            :close-on-select="false">

            <template slot="beforeList">
              <div class="d-flex align-items-center ml-2 selectAll">
                <input id="checkAllNaves" ref="checkAllNaves" type="checkbox"
                       @change="selectAllVessels($event, dataListaNave);">
                <label class="mt-2 ml-2" style="width:100%" for="checkAllNaves">Seleccionar todo</label>
              </div>
            </template>

          </multiselect>

        </div>

        <div class="col-6">
          <div style="color: grey; font-size: 15px">Naviera</div>
          <multiselect
            placeholder="Seleccionar"
            :options="dataListaNaviera"
            :searchable="true"
            v-model="carriers"
            :multiple="true"
            label="name"
            track-by="name"
            :limit="1"
            :limitText=" count => `+ ${count} registros` "
            selectLabel="Agregar"
            deselectLabel="Quitar"
            selectedLabel="Agregado"
            :close-on-select="false">

            <template slot="beforeList">
              <div class="d-flex align-items-center ml-2 selectAll">
                <input id="checkAllNav" ref="checkAllNav" type="checkbox"
                       @change="selectAllCarriers($event, dataListaNaviera);">
                <label class="mt-2 ml-2" style="width:100%" for="checkAllNav">Seleccionar todo</label>
              </div>
            </template>

          </multiselect>

        </div>

      </div>

      <div class="form-group row p-2">

        <div class="col-6">
          <div style="color: grey; font-size: 15px">Puerto de Carga (POL)</div>
          <multiselect
            placeholder="Seleccionar"
            :options="lista_puertos"
            :searchable="true"
            v-model="pols"
            :multiple="true"
            label="name"
            track-by="name"
            :limit="1"
            :limitText=" count => `+ ${count} registros` "
            selectLabel="Agregar"
            deselectLabel="Quitar"
            selectedLabel="Agregado"
            :close-on-select="false">

            <template slot="beforeList">
              <div class="d-flex align-items-center ml-2 selectAll">
                <input id="checkAllPols" ref="checkAllPols" type="checkbox"
                       @change="selectAllPols($event, lista_puertos);">
                <label class="mt-2 ml-2" style="width:100%" for="checkAllPols">Seleccionar todo</label>
              </div>
            </template>

          </multiselect>

        </div>

        <div class="col-6">
          <div style="color: grey; font-size: 15px">Puerto de Descarga (POD)</div>
          <multiselect
            placeholder="Seleccionar"
            :options="lista_puertos"
            :searchable="true"
            v-model="pods"
            :multiple="true"
            label="name"
            track-by="name"
            :limit="1"
            :limitText=" count => `+ ${count} registros` "
            selectLabel="Agregar"
            deselectLabel="Quitar"
            selectedLabel="Agregado"
            :close-on-select="false">

            <template slot="beforeList">
              <div class="d-flex align-items-center ml-2 selectAll">
                <input id="checkAllPods" ref="checkAllPods" type="checkbox"
                       @change="selectAllPods($event, lista_puertos);">
                <label class="mt-2 ml-2" style="width:100%" for="checkAllPods">Seleccionar todo</label>
              </div>
            </template>

          </multiselect>

        </div>

      </div>

      <div class="form-group row p-2">

        <div class="col-6">
          <div style="color: grey; font-size: 15px; margin-bottom: 10px;">Desde Fecha Embarque</div>
          <input
            class="form-control"
            placeholder="Seleccionar fecha"
            v-model="from_date"
            type="date"
          />
        </div>

        <div class="col-6">
          <div style="color: grey; font-size: 15px; margin-bottom: 10px;">Hasta Fecha Embarque</div>
          <input
            class="form-control"
            placeholder="Seleccionar fecha"
            v-model="to_date"
            type="date"
          />
        </div>

      </div>

      <div class="form-group row p-2">

        <ui-select class="col-12"
                   has-search
                   label="Estado de Booking"
                   placeholder="Seleccionar"
                   searchPlaceholder="Buscar"
                   :keys="{ label: 'name', value: 'id' }"
                   :options="[{ id: '2', name: 'Confirmado' }, { id: '5', name: 'Embarcado' }]"
                   v-model="booking_status">
        </ui-select>

      </div>

      <p class="h6 ml-3">
        <b>Nota:</b> Ninguno de los filtros es obligatorio; puede aplicar uno, varios o ninguno según sus necesidades.
      </p>

      <div class="d-flex justify-content-between mt-5">

        <button class="btn btn-default" @click="closeModal('modal')">
          Cerrar
        </button>

        <div style="float: right">

          <button
            class="btn btn-secondary"
            style="margin-right: 50px"
            @click="clear">
            Limpiar
          </button>

          <button class="btn btn-danger mr-3" @click="is_report_filter ? generateReport() : filter()"
                  :disabled="!filter_btn_active">
            {{ filter_btn_text }}
          </button>

        </div>
      </div>
    </ui-modal>
  </div>
</template>

<script>
import UiSelect from "keen-ui/src/UiSelect";
import UiTextbox from "keen-ui/src/UiTextbox";
import UiModal from "keen-ui/src/UiModal";
import Button from "@/components/common/Button";
import Multiselect from "vue-multiselect";
import { mapActions, mapState } from "vuex";

import { generateTrackingReport, getTrackingBookingsFiltered } from "@/constants/lineas";

export default {
  data() {

    return {
      id_booking: "",
      booking_number: "",
      carrier_booking_number: "",
      vessels: [],
      carriers: [],
      booking_status: "",
      status: "",
      delay_status: "",
      pods: [],
      pols: [],
      from_date: "",
      to_date: "",
      year: "",
      customer: "",
      filter_btn_text: "Filtrar",
      filter_btn_active: true,
      is_report_filter: false
    };

  },

  computed: {

    ...mapState("lineas", [
      "dataDatatableTrackingBookingsFiltered",
      "dataDatatableTrackingBookings",
      "dataSemanas",
      "listaClientes",
      "dataListaNaviera",
      "lista_puertos",
      "lista_anios",
      "dataListaNave"
    ]),

    ...mapState(["usuarioActual"])

  },

  components: {
    Multiselect,
    UiSelect,
    UiTextbox,
    UiModal,
    Button
  },

  methods: {

    ...mapActions(["ActionSetZindexTablaModal"]),

    ...mapActions("lineas", [
      "actionSetDataDatatableTrackingBookings",
      "actionSetDataDatatableTrackingBookingsFiltered",
      "actionFilterDataEmbarcado",
      "actionLimpiarDataEmbarcado"
    ]),

    ////////////////////////////////////////////////////////////////////////////
    selectAllCarriers(event, options) {

      if (event.target.checked) {

        this.carriers = options;

      } else {

        this.carriers = [];

      }
    },

    selectAllVessels(event, options) {

      if (event.target.checked) {

        this.vessels = options;

      } else {

        this.vessels = [];

      }
    },

    selectAllPols(event, options) {

      if (event.target.checked) {

        this.pols = options;

      } else {

        this.pols = [];

      }
    },

    selectAllPods(event, options) {

      if (event.target.checked) {

        this.pods = options;

      } else {

        this.pods = [];

      }
    },


    ////////////////////////////////////////////////////////////////////////////

    async clear() {

      this.id_booking = "";

      this.booking_number = "";

      this.carrier_booking_number = "";

      this.vessels = [];

      this.carriers = [];

      this.booking_status = "";

      this.status = "";

      this.delay_status = "";

      this.pods = [];

      this.pols = [];

      this.from_date = "";

      this.to_date = "";

      this.year = "";

      this.customer = "";

    },

    async filter() {

      try {

        this.$vToastify.loader("Filtrando datos...");

        this.loadingButton(false);

        let filters = {
          id_booking: this.id_booking ?? null,
          booking_number: this.booking_number ?? null,
          carrier_booking_number: this.carrier_booking_number ?? null,
          vessels:this.vessels.map(x => x.name) ?? null,
          carriers: this.carriers.map(x => x.id) ?? null,
          booking_status: this.booking_status.id ?? null,
          status: this.status.id ?? null,
          delay_status: this.delay_status.id ?? null,
          pods: this.pods.map(x => x.id) ?? null,
          pols: this.pols.map(x => x.id) ?? null,
          from_date: this.from_date ?? null,
          to_date: this.to_date ?? null,
          year: this.year.id ?? null,
          customer: this.customer.id ?? null
        };

        let tracking_bookings = await getTrackingBookingsFiltered(filters);

        this.actionSetDataDatatableTrackingBookingsFiltered(tracking_bookings.data);

        this.$vToastify.stopLoader();

        this.loadingButton(true);

        this.closeModal("modal");

      } catch (error) {

        console.log(error);

        this.$vToastify.stopLoader();

        this.loadingButton(true);

      }

    },

    async generateReport() {

      try {

        this.$vToastify.loader("Generando reporte de tracking...");

        this.loadingButton(false);

        let filters = {
          id_booking: this.id_booking ?? null,
          booking_number: this.booking_number ?? null,
          carrier_booking_number: this.carrier_booking_number ?? null,
          booking_status: this.booking_status.id ?? null,
          vessels: this.vessels.map(x => x.name) ?? null,
          carriers: this.carriers.map(x => x.id) ?? null,
          status: this.status.id ?? null,
          delay_status: this.delay_status.id ?? null,
          pods: this.pods.map(x => x.id) ?? null,
          pols: this.pols.map(x => x.id) ?? null,
          from_date: this.from_date ?? null,
          to_date: this.to_date ?? null,
          year: this.year.id ?? null,
          customer: this.customer.id ?? null
        };

        const response = await generateTrackingReport(filters);

        this.$vToastify.stopLoader();

        if (response.status === 200) {

          this.$vToastify.success("Cuando el reporte se haya generado será enviado a su correo electrónico, esto puede tardar algunos minutos", response.message);

        } else {

          this.$vToastify.error(response.message, "¡Error!");

        }

        this.$vToastify.stopLoader();

        this.loadingButton(true);

        this.closeModal("modal");

      } catch (error) {

        console.log(error);

        this.$vToastify.stopLoader();

        this.loadingButton(true);

      }


    },

    async removeFilters() {

      this.clear();

      this.actionSetDataDatatableTrackingBookingsFiltered(false);

    },

    loadingButton(active) {

      if (!active) {

        this.filter_btn_text = this.is_report_filter ? "Generando reporte..." : "Filtrando...";

        this.filter_btn_active = active;

      } else {

        this.filter_btn_text = this.is_report_filter ? "Generar reporte" : "Filtrar";

        this.filter_btn_active = active;

      }

    },

    openModal(ref, type) {

      if (type !== 1) {

        this.is_report_filter = true;

        this.filter_btn_text = "Generar reporte";

      } else {

        this.filter_btn_text = "Filtrar";

        this.is_report_filter = false;

      }

      this.$refs[ref].open();

    },

    closeModal(ref) {

      this.$refs[ref].close();

      this.is_report_filter = false;

    }

  }

};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>

.mx-input {
  padding-left: 2px !important;
  border-radius: 0px !important;
  border: 1px !important;
  border-bottom: 1px solid #dcdcdc !important;
  box-shadow: none !important;
}

.multiselect__tags {
  border-radius: 0px !important;
  border: 1px !important;
  border-bottom: 1px solid #e8e8e8 !important;
  font-size: 16px !important;
  padding: 4px 40px 0 8px !important;
  min-height: 32px;
}

.multiselect, .multiselect__input, .multiselect__single {
  font-size: 14px;
}
</style>
